import { Component, Input, OnInit } from "@angular/core";
import { Clipboard } from '@capacitor/clipboard';
import { MarketModel } from "src/app/models/market.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { ShareService } from "src/app/services/share/share.service";
/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "share",
  templateUrl: "share.component.html",
  styleUrls: ["./share.component.scss"]
})
export class ShareComponent implements OnInit {
 
  @Input()
  public onShared = () => {}
  
  @Input()
  tournee: TourneeModel | MarketModel;


  @Input()
  producer: ProfileModel;

  link: string;

  constructor(public shareService:ShareService) {

  }

  ngOnInit() {}

  fb(){
    this.shareService.shareTourneeFB(this.tournee);
  }

  copyLink(){
    const link =  this.getLink();
    Clipboard.write({
      string: link
    });
  }

  getLink(){
    if(!this.link){
      this.link =  this.tournee?this.shareService.getSaleURL(this.tournee): this.shareService.getProfileURL(this.producer);
    }
    return this.link;
  }

  qr(parent) {
    // fetches base 64 date from image
    console.log(parent);
    const parentElement = parent.qrcElement.nativeElement
    .querySelector("canvas")
    .toDataURL("image/png");

    // converts base 64 encoded image to blobData
    let blobData = this.convertBase64ToBlob(parentElement);

    // saves as image
    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = (this.tournee?this.tournee.details.name: this.producer.details.shortDetails.name)+ '_QRcode';
    link.click();
  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }
}
